import React, { useState, useEffect } from 'react';
import { navigate } from 'gatsby';
import OfferPoints from './OfferPoints';
import styled from 'styled-components';
import { Subhead, Caption1 } from '../../../../components/Typography';

const Card = styled.div`
  border-radius: 13px;
  box-shadow: 0 4px 14px 0 rgba(66, 59, 112, 0.32);
  background-color: white;
  cursor: pointer;
  height: 289px;
  width: 434px;

  &:hover {
    box-shadow: 0 2px 7px 0 rgba(66, 59, 112, 0.24);
    transition: all 0.25s ease;
  }

  // @media (min-width: 768px) and (max-width: 1440px) {
  //   width: 314px;
  //   height: 209px;
  // }

  @media (max-width: ${(props) => props.mediaQueryMaxWidth || '1440px'}) {
    width: 314px;
    height: 209px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const CardImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-top-left-radius: 13px;
  border-top-right-radius: 13px;
  filter: ${(props) => (props.isDisabled ? 'grayscale(0.90)' : 'grayscale(0)')};
`;

const CardText = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  background-color: white;
  padding: 8px;
  border-bottom-left-radius: 13px;
  border-bottom-right-radius: 13px;
  border-top: 1px solid #f5f4f9;
  align-items: center;
`;

const DescriptionText = styled.div`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 400px;
  font-weight: 300;
  color: #000;
`;
const TitleText = styled(Subhead)`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 400px;
`;

const ImageContainer = styled.div`
  height: 226px;
  position: relative;
  text-align: center;
  color: white;

  @media (min-width: 768px) and (max-width: ${(props) =>
      props.mediaQueryMaxWidth || '1550px'}) {
    height: 146px;
  }
  @media (max-width: ${(props) => props.mediaQueryMaxWidth || '1550px'}) {
    height: 70%;
  }
`;

const LockIcon = styled.i`
  position: absolute;
  left: 20px;
  bottom: 16px;
  color: white;
  font-size: 24px;
`;

const OfferCardMenuPage = ({ offer, mediaQueryMaxWidth }) => {
  const limitCharsToShow = 20;
  const [offerActivateButtonText, setOfferActivateButtonText] = useState('');
  const [isOfferDisabled, setIsOfferDisabled] = useState(true);
  return (
    <>
      <Card
        mediaQueryMaxWidth={mediaQueryMaxWidth}
        onClick={() => navigate('/offers')}
      >
        <ImageContainer>
          <CardImage
            src={offer.image_url}
            mediaQueryMaxWidth={mediaQueryMaxWidth}
            isDisabled={isOfferDisabled}
          ></CardImage>
          {!offer?.eligible && !offer?.activated && (
            <LockIcon className='far fa-lock' />
          )}
          <OfferPoints
            offer={offer}
            setOfferActivateButtonText={setOfferActivateButtonText}
            setIsOfferDisabled={setIsOfferDisabled}
          />
        </ImageContainer>
        <CardText>
          <div>
            <div
              style={{
                overflow: 'hidden',
                position: 'relative',
                maxWidth: '400px',
              }}
            >
              <TitleText>{offer.title}</TitleText>
              <DescriptionText>{offer.subtitle}</DescriptionText>
            </div>
          </div>
        </CardText>
      </Card>
    </>
  );
};

export default OfferCardMenuPage;
